import React, { Component } from "react";
import { injectIntl, defineMessages } from "react-intl";

import { Button } from "semantic-ui-react";
import { EduTemplateAddEdit } from "components";

class EduTemplateMenu extends Component {
  state = {
    addModal: false,
  };

  toggleModal = () => {
    this.setState({
      addModal: !this.state.addModal,
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { addModal } = this.state;
    const { toggleModal } = this;

    return (
      <div className={"func-list"}>
        <Button
          className="bt-style-gleam common-button-brand"
          size="small"
          content={defineMessages(formatMessage({ id: "CtAdminUserAdd_1", defaultMessage: "등 록" }))}
          onClick={toggleModal}
          color="blue"
        />
        {addModal && <EduTemplateAddEdit addMode toggleModal={toggleModal} />}
      </div>
    );
  }
}

export default injectIntl(EduTemplateMenu);



// WEBPACK FOOTER //
// ./src/script/components/eduTemplate/EduTemplateMenu.js